import Error from '../model/Error.js';
import Helper from '../accounting/Helper.js';
import axios from 'axios';

export default class ClubInvoiceAssetRepository {

    static downloadXlsx(clubId, start, end) {
        return new Promise((resolve, reject) => {
            axios.get('/club/clubs/' + clubId + '/club-invoice-assets/xlsx?servicePeriod=' + start + ':' + end, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', new Helper().getFilenameFromHeaders(response.headers));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
